import React, { useState, useEffect, useRef } from "react";
import { Row, Col, Breadcrumb, Card, Form, Container } from "react-bootstrap";
import { TabView, TabPanel } from 'primereact/tabview';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import { Image } from 'primereact/image';
import { Button } from 'primereact/button';
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import "bootstrap-daterangepicker/daterangepicker.css";
import "bootstrap-daterangepicker";
import $ from "jquery";
import '../../assets/css/Shop.css'
import { Badge } from 'primereact/badge';
import { Sidebar } from 'primereact/sidebar';
import { InputTextarea } from "primereact/inputtextarea";
import { useAuth } from "../../context/AuthContext";
import api from "../../api/axios";
import { toast, Bounce } from "react-toastify";
import Report_data from "../../components/Report_data";

const emitToast = (message, type = "default", autoClose = 5000) => {
  toast(message, {
    position: "bottom-left",
    autoClose,
    hideProgressBar: false,
    closeOnClick: false,
    pauseOnHover: true,
    draggable: true,
    theme: "dark",
    transition: Bounce,
    type
  });
};
const Raiseticket = () => {
  const { username, userId, tierlevel, balance, creditlimit } = useAuth();
  const pickerRef = useRef(null);
  const [visibleRight, setVisibleRight] = useState(false);
  const [visibleRight2, setVisibleRight2] = useState(false);
  const [subject, setSubject] = useState('');
  const [category, setCategory] = useState('');
  const [issue, setIssue] = useState('');
  const [images, setImages] = useState([]);
  const [submitting, setSubmitting] = useState(false);


  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const getDefaultDates = () => {
    const today = new Date();

    // End of today (23:59:59.999)
    const end = new Date(today);
    end.setHours(23, 59, 59, 999);

    // Start date = 6 days before today, start of day
    const start = new Date(today);
    start.setDate(start.getDate() - 6);
    start.setHours(0, 0, 0, 0);

    const formatDate = (date) =>
      date.toISOString().split("T")[0];

    return {
      startDate: formatDate(start),
      endDate: formatDate(end),
    };
  };

  const { startDate: defaultStartDate, endDate: defaultEndDate } = getDefaultDates();

  const [startDate, setStartDate] = useState(defaultStartDate);
  const [endDate, setEndDate] = useState(defaultEndDate);


  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [totalPages, setTotalPages] = useState(1);

  const [selectedTicketId, setSelectedTicketId] = useState(null);



  useEffect(() => {
    if (!pickerRef.current) return;

    $(pickerRef.current).daterangepicker({
      autoUpdateInput: false,
      opens: "left",
      showDropdowns: true,
      linkedCalendars: false,
      locale: {
        format: "YYYY-MM-DD",
        cancelLabel: "Clear"
      }
    });

    $(pickerRef.current).on("apply.daterangepicker", function (ev, picker) {
      const start = picker.startDate.format("YYYY-MM-DD");
      const end = picker.endDate.format("YYYY-MM-DD");

      setStartDate(start);
      setEndDate(end);

      this.value = `${start} - ${end}`;
      setPage(1); // reset pagination
    });

    $(pickerRef.current).on("cancel.daterangepicker", function () {
      this.value = "";
      setStartDate("");
      setEndDate("");
      setPage(1);
    });


    return () => {
      $(pickerRef.current).data("daterangepicker")?.remove();
    };
  }, []);



  const fetchTickets = async () => {
    try {
      setLoading(true);

      const res = await api.get(`/ctickets/get_tickets`, {
        params: {
          searchTerm,
          startDate,
          endDate,
          page,
          limit,
        },
      });

      setTickets(res.data.data || []);
      setTotalPages(res.data.pagination.totalPages || 1);
    } catch (error) {
      console.error("Failed to fetch tickets", error);
      emitToast("Failed to fetch tickets", "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTickets();
  }, [searchTerm, startDate, endDate, page]);




  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);

    if (files.length > 5) {
      emitToast("Maximum 5 images allowed", "warning");
      e.target.value = null; 
      return;
    }

    setImages(files);
  };

  // const handleFileChange = (e) => {
  //   const files = Array.from(e.target.files);

  //   const allowedTypes = ["image/jpeg", "image/jpg", "image/png"];
  //   const maxSize = 5 * 1024 * 1024; // 5MB

  //   if (files.length > 5) {
  //     emitToast("Maximum 5 images allowed", "warning");
  //     e.target.value = null;
  //     return;
  //   }

    
  //   const invalidFile = files.find(
  //     (file) =>
  //       !allowedTypes.includes(file.type) || file.size > maxSize
  //   );

  //   if (invalidFile) {
  //     if (!allowedTypes.includes(invalidFile.type)) {
  //       emitToast("Only JPG, JPEG, and PNG files are allowed", "warning");
  //     } else if (invalidFile.size > maxSize) {
  //       emitToast("Each image must be less than 5MB", "warning");
  //     }
  //     e.target.value = null;
  //     return;
  //   }

  //   setImages(files);
  // };


  const handleSubmitTicket = async () => {
    if (!subject || !issue || !category) {
      emitToast("All fields are required", "warning");
      return;
    }
    if (images.length > 5) {
      emitToast("You can upload a maximum of 5 images only", "warning");
      return;
    }

    try {
      setSubmitting(true);

      const formData = new FormData();
      formData.append('subject', subject);
      formData.append('issue', issue);
      formData.append('category', category);

      images.forEach((file) => {
        formData.append('images', file);
      });

      await api.post('/ctickets/add_ticket', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      emitToast("Ticket created successfully", "success");
      // Reset form
      setSubject('');
      setCategory('');
      setIssue('');
      setImages([]);

      // Close sidebar & refresh list
      setVisibleRight(false);
      fetchTickets();

    } catch (error) {
      console.error('Ticket creation failed', error);

      emitToast(
        error?.response?.data?.message || "Failed to create ticket",
        "error"
      );
    }
    finally {
      setSubmitting(false);
    }
  };


  return (
    <>
      <Row className="mx-0 breadcrumb_part">
        <Col md={12} lg={12} xs={12} className="prof_title mb-4 p-0 d-flex justify-content-between align-items-center">
          <h4>Ticket List</h4>
          <div className="resp_rpadding">
            <Button
              label="Add Ticket"
              className="custbuttonpink billInfo py-1"
              style={{ fontSize: '16px', width: 'fit-content' }}
              onClick={() => setVisibleRight(true)}
            />
          </div>
        </Col>
        <Col md={12} lg={12} xs={12} className="p-0 mb-4 userDashtab">
          <div className="downloadTable">

            <div className="d-lg-flex justify-content-end align-items-center gap-2 w-100 filterpart responsivefilter mb-3">
              <span className="text-secondary">Filter by</span>

              <div>
                <input
                  ref={pickerRef}
                  type="text"
                  className="form-control"
                  placeholder="Select date range"
                />
              </div>

              <IconField iconPosition="left" style={{ width: '180px' }}>
                <InputText
                  placeholder="Search..."
                  className="ps-5"
                  value={searchTerm}
                  onChange={(e) => {
                    setSearchTerm(e.target.value);
                    setPage(1);
                  }}
                />

              </IconField>
              
            </div>

            <div className="table-wrapper invoice-table">
              <Table className="custom-table">
                <Thead className="sticky-thead">
                  <Tr>
                    <Th style={{ width: '240px' }}>Image</Th>
                    <Th>Category</Th>
                    <Th style={{ width: '140px' }}>Assigned To</Th>
                    <Th style={{ width: '180px' }}>Issue</Th>
                    <Th style={{ width: '180px' }}>Remark</Th>
                    <Th>Status</Th>
                    <Th style={{ width: '120px' }}>Action</Th>
                  </Tr>
                </Thead>

                <Tbody>
                  {loading ? (
                    <Tr>
                      <Td colSpan="7" className="text-center">Loading...</Td>
                    </Tr>
                  ) : tickets.length === 0 ? (
                    <Tr>
                      <Td colSpan="7" className="text-center text-secondary">No tickets found</Td>
                    </Tr>
                  ) : (
                    tickets.map((ticket) => (
                      <Tr key={ticket.ticket_id} className="table-row">
                        <Td>
                          <div className="d-flex gap-3 align-items-center">
                            {/* {ticket.images?.length > 0 && (
                              <Image
                                src={ticket.images[0].image_url_ticket}
                                alt="Ticket"
                                width="60"
                                height="60"
                                preview
                              />
                            )} */}

                            <div>
                              <b>{ticket.subject}</b>
                              <small className="d-block mt-1 text" style={{ fontSize: '15px', fontWeight: '500', lineHeight: '1' }}>
                                {/* <Badge value={ticket.ticket_no} severity="secondary" /> */}
                                No. :
                                <small>{ticket.ticket_no}</small>
                              </small>

                            </div>
                          </div>
                        </Td>

                        <Td><span>{ticket.category}</span></Td>

                        <Td>
                          <span>
                            {ticket.resolver
                              ? `${ticket.resolver.first_name} ${ticket.resolver.last_name}`
                              : 'Unassigned'}
                          </span>
                        </Td>

                        <Td>
                          <p className="text-truncate" style={{ maxWidth: '180px' }}>
                            {ticket.issue}
                          </p>
                        </Td>

                        <Td>
                          <p className="text-truncate" style={{ maxWidth: '180px' }}>
                            {ticket.remark || 'No data'}<br />

                          </p>
                        </Td>

                        <Td>
                          <Badge
                            value={ticket.status}
                            severity={
                              ticket.status === 'New_ticket'
                                ? 'info'
                                : ticket.status === 'Closed'
                                  ? 'success'
                                  : 'warning'
                            }
                          />
                        </Td>

                        <Td>
                          <Button
                            icon="pi pi-eye"
                            text
                            className="p-0"
                            tooltip="View All"
                            style={{ fontSize: '1rem', lineHeight: '1.2', width: '34px' }}
                            severity="success"
                            onClick={() => {
                              setSelectedTicketId(ticket.ticket_id);
                              setVisibleRight2(true);
                            }}

                          />
                          <Button
                            icon="pi pi-trash"
                            severity="danger"
                            text
                            className="p-0"
                            tooltip="Delete"
                            style={{ fontSize: '1rem', lineHeight: '1.2', width: '34px' }}
                          />
                        </Td>
                      </Tr>
                    ))
                  )}
                </Tbody>

              </Table>
              <div className="d-flex justify-content-between align-items-center gap-2 mt-3">
                <div>
                  <span className="text-secondary">
                    Page {page} of {totalPages}
                  </span>
                </div>
                <div>
                  <Button
                    label="Prev"
                    disabled={page === 1}
                    onClick={() => setPage((p) => p - 1)}
                    className="px-2 py-1 me-2"
                    style={{ fontSize: '14px', lineHeight: '1.2' }}
                    severity="warning"
                  />
                  <Button
                    label="Next"
                    disabled={page === totalPages}
                    onClick={() => setPage((p) => p + 1)}
                    className="px-2 py-1"
                    style={{ fontSize: '14px', lineHeight: '1.2' }}
                    severity="warning"
                  />
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <Sidebar className="shortCartSide" visible={visibleRight} position="right" onHide={() => setVisibleRight(false)} style={{ width: '500px' }}>
        <h4>Raise a Query</h4>
        <div className="d-flex flex-column gap-2 mt-3 user-dash">
          {/* Subject */}
          <div className="d-flex flex-column gap-1">
            <label>Issue *</label>
            <InputText
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
            />

          </div>
          <div className="d-flex flex-column gap-1">
            <label>Category *</label>
            <Form.Select
              value={category}
              onChange={(e) => setCategory(e.target.value)}
            >
              <option value="">Select category</option>
              <option value="Payment_Issue">Payment Issue</option>
              <option value="Access_Issue">Access Issue</option>
              <option value="Promotion_Not_Working">Promotion Not Working</option>
              <option value="Refund">Refund</option>
              <option value="Others">Others</option>
            </Form.Select>

          </div>
          <div className="d-flex flex-column gap-1">
            <label>Description *</label>
            <InputTextarea
              value={issue}
              onChange={(e) => setIssue(e.target.value)}
              rows={3}
              cols={30} />
          </div>
          <div className="d-flex flex-column gap-1">
            <Form.Group controlId="formFile" className="mb-3">
              <label>Upload Images *</label>
              <Form.Control
                type="file"
                multiple
                accept="image/*"
                onChange={handleFileChange}
              />
              <small style={{ color: '##757575' }}>
                Max 5 images (JPG, JPEG, PNG).
              </small>
            </Form.Group>
          </div>
          <div className="d-flex justify-content-end mt-4">
            <Button
              label="Cancel"
              className="py-2 me-2"
              severity="secondary"
              style={{ width: 'fit-content', fontSize: '18px' }}
              onClick={() => setVisibleRight(false)}
            />
            <Button
              label={submitting ? 'Submitting...' : 'Submit'}
              className="py-2 custbuttonpink"
              style={{ width: 'fit-content', fontSize: '18px' }}
              onClick={handleSubmitTicket}
            />

          </div>
        </div>
      </Sidebar>

      {/* Report sidebar */}

      <Sidebar
        className="shortCartSide"
        visible={visibleRight2}
        position="right"
        onHide={() => {
          setVisibleRight2(false);
          setSelectedTicketId(null);
        }}
        style={{ width: '500px' }}
        dismissable={false}
        closeOnEscape={false}
      >
        <Report_data ticketId={selectedTicketId} />
      </Sidebar>

    </>
  );
};

export default Raiseticket;